import '../About/About.scss';
import React, { Component, Fragment } from 'react';
import { SettingOptions, SettingsHeader } from '../Settings';
import PropTypes from 'prop-types';
import {} from '../images';
import { connect } from 'react-redux';
import { wallpaperPreviewSection } from '../../../../Actions/WallpaperActions';
import Wallpaper from './Wallpaper';
class Chats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parentStatus: true,
            activeTab: null,
        };
    }

    backToChat = () => {
        this.setState({
            parentStatus: true,
            activeTab: null,
        });
        this.props.wallpaperPreviewSection(false);
    };

    handleWallpaper = label => {
        this.setState({
            parentStatus: false,
            activeTab: label,
        });
        this.props.wallpaperPreviewSection(true);
    };

    handlePopupClose = () => {
        this.setState({
            parentStatus: true,
            activeTab: null,
        });
    };

    render() {
        let { parentStatus, activeTab } = this.state;
        const { handleBackToSetting } = this.props;

        return (
            <Fragment>
                {parentStatus && (
                    <div className="setting-container">
                        <div>
                            <div className="settinglist">
                                <SettingsHeader handleBackFromSetting={handleBackToSetting} label={'Chats'} />
                                <ul className="setting-list-ul About">
                                    <SettingOptions
                                        label={'Wallpaper'}
                                        handleOptions={() => this.handleWallpaper('wallpaper')}
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
                {!parentStatus && (
                    <Fragment>{activeTab === 'wallpaper' && <Wallpaper backToChat={this.backToChat} />}</Fragment>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = _state => ({});

const mapDispatchToProps = {
    wallpaperPreviewSection,
};

export default connect(mapStateToProps, mapDispatchToProps)(Chats);

Chats.propTypes = {
    handleBackToSetting: PropTypes.func,
    wallpaperPreviewSection: PropTypes.func,
};
